import React from "react";

import Head from "./head";
import OrderSummary from "./orderSummary";
import OrderActions from "./orderActions";
import SplitBillPanel from "./splitBillPanel";

const Order = ({
  order,
  loading,
  productAsDone,
  payOut,
  updateOrder,
  print,
  changeTable,
  saveUser,
  sendPaymentLink,
  splitBillMode,
  enterSplitBillMode,
  exitSplitBillMode,
  selectedProducts,
  toggleProductSelection,
  getSelectedTotal,
  getAlreadySplitProductIds,
  billSplits,
  addBillSplit,
  removeBillSplit,
  finalizeBillSplit,
  splitPaying,
  billPaymentType,
  setBillPaymentType,
  billCardType,
  setBillCardType,
  settings,
  printSplitBillTicket,
}) => (
  <div className="container">
    <Head order_id={order.id} status={order.status} />
    <div className="row">
      <OrderSummary
        loading={loading}
        order={order}
        productAsDone={splitBillMode ? null : productAsDone}
        changeTable={splitBillMode ? null : changeTable}
        saveUser={splitBillMode ? null : saveUser}
        splitBillMode={splitBillMode}
        selectedProducts={selectedProducts}
        toggleProductSelection={toggleProductSelection}
        alreadySplitIds={splitBillMode ? getAlreadySplitProductIds() : {}}
      />
      {splitBillMode ? (
        <SplitBillPanel
          order={order}
          selectedTotal={getSelectedTotal()}
          billSplits={billSplits}
          addBillSplit={addBillSplit}
          removeBillSplit={removeBillSplit}
          finalizeBillSplit={finalizeBillSplit}
          exitSplitBillMode={exitSplitBillMode}
          splitPaying={splitPaying}
          billPaymentType={billPaymentType}
          setBillPaymentType={setBillPaymentType}
          billCardType={billCardType}
          setBillCardType={setBillCardType}
          settings={settings}
          printSplitBillTicket={printSplitBillTicket}
        />
      ) : (
        <OrderActions
          order={order}
          payOut={payOut}
          updateOrder={updateOrder}
          print={print}
          sendPaymentLink={sendPaymentLink}
          enterSplitBillMode={enterSplitBillMode}
        />
      )}
    </div>
  </div>
);

export default Order;
